// extracted by mini-css-extract-plugin
export default {"dropDownWrapper":"offers_dropDownWrapper__x9ne6","graphDropDown":"offers_graphDropDown__f3SPo","dropDown":"offers_dropDown__hxBgu","textArea":"offers_textArea__gO41Z"};